import { ArrowForwardOutlined } from "@material-ui/icons";
import { Fragment } from "react";
import { Col } from "reactstrap";
import ErrorBlock from "../../../assets/ErrorBlock";
import './../index.scss'

const ErrorSection = ({props, text, goBack}) => {

    return (
        <Fragment>
            <div className="checkEligibiltyForm">
                <Col md={12}>
                    <ErrorBlock />
                    <h1>{text}</h1>
                    <span onClick={() => goBack()}>Try using another PAN No. <ArrowForwardOutlined style={{ fontSize : 18, color:'#1678FB'}} /></span>
                </Col>
            </div>
        </Fragment>
    )
}

export default ErrorSection;